import { FeedbackForm } from './feedback-form'
import Modals from 'application/ui/modal/modal'
import { YandexMap } from 'application/shared/yandex-map'
import { QuestCategories } from './categories'

export function initFeedbackForm(): void {
  const feedbackFormEl = document.querySelector<HTMLElement>(
    '[data-form="feedback"]'
  )
  if (!feedbackFormEl) {
    return
  }

  new FeedbackForm(feedbackFormEl)
}

export function initCategories(): void {
  const categories = document.querySelectorAll<HTMLElement>(
    '[data-quest-categories]'
  )

  categories.forEach((categoriesEl) => new QuestCategories(categoriesEl))
}

/**
 * Карта квеста в модалке «Показать на карте»: API Яндекс Карт грузится и карта
 * создаётся только при первом открытии, дальше модалка показывает ту же карту.
 */
export function initQuestMapModal(): void {
  const container = document.querySelector<HTMLElement>('[data-quest-map]')
  if (!container) {
    return
  }

  const center = [
    Number(container.dataset.latitude),
    Number(container.dataset.longitude)
  ]
  let map: { container: { fitToViewport: () => void } } | null = null

  const showMap = async () => {
    if (map) {
      map.container.fitToViewport()
      return
    }

    const ymaps = await YandexMap.getAPI()
    ymaps.ready(() => {
      const created = new ymaps.Map(container, {
        center,
        zoom: 16,
        controls: ['zoomControl']
      })
      created.geoObjects.add(
        new ymaps.Placemark(
          center,
          { hintContent: container.dataset.title },
          {
            iconLayout: 'default#image',
            iconImageHref: '/images/wizard/map/marker.svg',
            iconImageSize: [40, 40],
            iconImageOffset: [-20, -20]
          }
        )
      )
      map = created
    })
  }

  Modals.getInstance().addModal(
    'quest_map_modal',
    {
      eventTimeout: 300,
      openCallback: () => {
        void showMap()
      }
    },
    true
  )
}
